import React, { useState, useEffect } from "react";
import { useAuth } from './AuthContext';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"

const validationSchema = yup.object({
    owner: yup.string().required("Owner App is required"),
    userName: yup.string().required("User Name is required"),
    expiresAt: yup.date()
        .required('Expiry date is required')
        .typeError('Please enter a valid date')
}).required()

export default function EditAppUser() {
    const [appUser, setAppUser] = useState([]);
    const [endUsers, setEndUsers] = useState([]);
    const { secureFetch } = useAuth();
    const navigate = useNavigate();
    // Destructure the parameter name you defined in the Route path
    const { id } = useParams();

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        values: appUser, // Automatically populates when data is available
    })

    var screenHeader = '';
    if (id)
        screenHeader = "Update App User";
    else
        screenHeader = "Create New App User";

    useEffect(() => {
        var myAsyncFunction = async () => {
            var response = await secureFetch('api/auth/users');
            if (response.ok) {
                const data = await response.json();
                setEndUsers(data);
            }

            if (id) {
                let appUserData = {};
                response = await secureFetch(`api/auth/appuser/${id}`);
                if (response.ok) {
                    appUserData = await response.json();
                    appUserData.createdAt = new Date(appUserData.createdAt).toISOString().split('T')[0];
                    appUserData.expiresAt = new Date(appUserData.expiresAt).toISOString().split('T')[0];
                    setAppUser(appUserData);
                }
            }
            else {
                let newAppUserInfo = {
                    id: null,
                    owner: null,
                    userName: null,
                    createdAt: new Date().toISOString().split('T')[0], // Set to today's date
                    expiresAt: null,
                    isActive: true
                };
                setAppUser(newAppUserInfo);
            }
        }
        myAsyncFunction();
    }, []);

    function navigateBack(e) {
        navigate('/admin/appusers');
    }

    async function onSubmit(data) {
        //alert('OA OA');
        console.log('Form Data:', data);
        //build the payload
        const payload = {
            ...data,
            // Only include ID if we are in "Edit" mode (id from useParams exists)
            ...(id && { id: id })
        };
        let createOrUpdate = data.id ? 'update' : 'create';

        const response = await secureFetch('api/auth/appuser/' + createOrUpdate, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (response.ok) {
            alert(`App User ${createOrUpdate}d successfully.`);
            navigateBack();
        } else {
            alert(`Failed to ${createOrUpdate} App User.`);
        }
    }

    return (
        <>
            <div className="form-horizontal">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h4>{screenHeader}</h4>
                    <hr />
                    <div className="form-floating mb-2">
                        <input {...register("owner")} class="form-control" autocomplete="username" aria-required="true" />
                        <label for="owner" className="form-label">Owner App</label>
                        <div>&nbsp; {errors.owner && <span className="text-danger">{errors.owner.message}</span>}</div>
                    </div>
                    <div className="form-floating mb-2">
                        <select
                            {...register("userName")}
                            className={`form-select ${errors.userName ? 'is-invalid' : ''}`}
                            id="userName" // ID must match the 'for' attribute in the label
                            aria-label="User name"
                        >
                            {/* Bootstrap 5 floating labels require an empty first option or placeholder */}
                            <option value="">Select a user...</option>
                            {endUsers.map((usr) => (
                                <option key={usr.username} value={usr.username}>
                                    {usr.username}
                                </option>
                            ))}
                        </select>

                        <label htmlFor="userName">User Name</label>

                        <div>
                            &nbsp; {errors.userName && <span className="text-danger">{errors.userName.message}</span>}
                        </div>
                    </div>
                    <div className="form-floating mb-2">
                        <input {...register("expiresAt")} type="date" className="form-control" autocomplete="on" aria-required="true" />
                        <label for="expiresAt" className="form-label">Expires At</label>
                        <div>&nbsp; {errors.expiresAt && <span className="text-danger">{errors.expiresAt.message}</span>}</div>
                    </div>
                    <div className="form-group form-row mt-4">
                        <div class="d-flex justify-content-start">
                                <button id="user-submit" type="submit" class="btn btn-lg btn-primary">Save</button>
                                <button id="user-cancel" type="button" class="btn btn-lg btn-primary ms-3" onClick={ navigateBack }>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}